// extracted by mini-css-extract-plugin
module.exports = {"requiredNotice":"RPXc7"};